export const FIELDS_ACTIVITIES_QUERY_KEY = 'fieldsActivities';
